import React from 'react';
import PropTypes from 'prop-types';
import Captcha from '../Captcha';
import Field from '../Field';
import Input from '../Input';
import styles from './styles.module.scss';

export default class CaptchaField extends React.Component {
  static propTypes = {
    captchaUrl: PropTypes.string.isRequired,
  };

  captchaRef = ref => {
    this.captcha = ref;
  };

  refresh = () => {
    this.captcha.refresh();
  };

  render() {
    const { captchaUrl, ...props } = this.props;

    return (
      <Field {...props}>
        {({ inputProps, help }) => (
          <div>
            <Captcha ref={this.captchaRef} url={captchaUrl} />
            <div className={styles['field']}>
              <Input {...inputProps} />
              {help}
            </div>
          </div>
        )}
      </Field>
    );
  }
}
